import { apiClient, unwrap } from './client';
import type { ApiResponse, PagedResult } from '@/types/api';
import type {
  CreateEnterpriseRequest,
  EnterpriseDto,
  EnterpriseListRequest,
  UpdateEnterpriseRequest,
  GenerateSignupUrlRequest,
  SignupUrlDto,
  CompleteEnterpriseSignupRequest,
} from '@/types/enterprise';

export const enterprisesApi = {
  list(request: EnterpriseListRequest = {}): Promise<PagedResult<EnterpriseDto>> {
    return unwrap(
      apiClient.get<ApiResponse<PagedResult<EnterpriseDto>>>('/enterprises', {
        params: request,
      }),
    );
  },

  getById(id: number): Promise<EnterpriseDto> {
    return unwrap(apiClient.get<ApiResponse<EnterpriseDto>>(`/enterprises/${id}`));
  },

  create(request: CreateEnterpriseRequest): Promise<EnterpriseDto> {
    return unwrap(apiClient.post<ApiResponse<EnterpriseDto>>('/enterprises', request));
  },

  update(id: number, request: UpdateEnterpriseRequest): Promise<EnterpriseDto> {
    return unwrap(apiClient.put<ApiResponse<EnterpriseDto>>(`/enterprises/${id}`, request));
  },

  deactivate(id: number): Promise<void> {
    return apiClient.delete(`/enterprises/${id}`).then(() => undefined);
  },

  reactivate(id: number): Promise<void> {
    return apiClient.post(`/enterprises/${id}/reactivate`).then(() => undefined);
  },

  // === Signup flow ===

  generateSignupUrl(request: GenerateSignupUrlRequest): Promise<SignupUrlDto> {
    return unwrap(apiClient.post<ApiResponse<SignupUrlDto>>('/enterprises/signup-url', request));
  },

  completeSignup(request: CompleteEnterpriseSignupRequest): Promise<EnterpriseDto> {
    return unwrap(apiClient.post<ApiResponse<EnterpriseDto>>('/enterprises/signup-complete', request));
  },
};
